"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioTabsVariations = void 0;
var RadioTabsVariations;
(function (RadioTabsVariations) {
    RadioTabsVariations["TAB_A"] = "tabA";
    RadioTabsVariations["TAB_B"] = "tabB";
    RadioTabsVariations["TAB_C"] = "tabC";
    RadioTabsVariations["TAB_D"] = "tabD";
    RadioTabsVariations["TAB_Invalid"] = "tabInvalid";
})(RadioTabsVariations = exports.RadioTabsVariations || (exports.RadioTabsVariations = {}));
//# sourceMappingURL=RadioTabProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Tabs/components/RadioTab/RadioTabProps.js
// module id = 461
// module chunks = 8